// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-icon-caret-top[data-v-71651314],\n.el-icon-caret-bottom[data-v-71651314] {\n  font-size: 20px;\n  line-height: 15px;\n  text-align: center;\n  background: white;\n}\n.main-content[data-v-71651314] .dw-report.el-table td.el-table__cell.link {\n  color: #3300ff;\n  text-decoration: underline;\n  cursor: pointer;\n  background: #ccffff;\n}\n", ""]);
// Exports
module.exports = exports;
